import { useScreenSize } from '@/hooks';
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
    color?: string;
    width?: number | string;
    height?: number | string;
}

export const CalendarIcon = (props: Props) => {
    const { color = '#444444', width = 16, height = 17, ...rest } = props;

    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    const numericWidth = typeof width === 'string' ? parseFloat(width) : width;
    const numericHeight = typeof height === 'string' ? parseFloat(height) : height;

    return (
        <svg
            width={scaleWidthPixel(numericWidth)}
            height={scaleHeightPixel(numericHeight)}
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <rect x="0.7" y="2.03398" width="14.6" height="13.7111" stroke={color} strokeWidth="1.4" />
            <rect x="4" width="1.5" height="4" fill={color} />
            <rect x="10.5" width="1.5" height="4" fill={color} />
            <line x1="0.00497123" y1="7.68869" x2="16.0049" y2="7.79953" stroke={color} strokeWidth="1.4" />
        </svg>
    );
};
